import axios, { AxiosResponse } from 'axios';
import type {
    IMonitoringAccountListResponse,
    IMonitoringBettingListResponse,
    IMonitoringBookmakerListResponse,
    IMonitoringProxyListResponse,
    IMonitoringServerTime,
    IMonitoringSettlementListResponse,
} from '@/types';

export const monitoringBookmakerList = (): Promise<AxiosResponse<IMonitoringBookmakerListResponse>> => {
    return axios.get('/api/monitoring/bookmaker/list', {
        params: {
            requiredDictionaries: ['Country', 'SiteAll'],
        },
    });
};

export const monitoringProxyList = (): Promise<AxiosResponse<IMonitoringProxyListResponse>> => {
    return axios.get('/api/monitoring/proxy/list', {
        params: {
            requiredDictionaries: ['Country', 'Proxy'],
        },
    });
};

export const monitoringAccountList = (): Promise<AxiosResponse<IMonitoringAccountListResponse>> => {
    return axios.get('/api/monitoring/account/list', {
        params: {
            requiredDictionaries: ['SiteAll'],
        },
    });
};

export const monitoringBettingList = (): Promise<AxiosResponse<IMonitoringBettingListResponse>> => {
    return axios.get('/api/monitoring/betting/list', {
        params: {
            requiredDictionaries: ['Country', 'SiteAll', 'Proxy'],
        },
    });
};

export const monitoringSettlementList = (): Promise<AxiosResponse<IMonitoringSettlementListResponse>> => {
    return axios.get('/api/monitoring/settlement/list', {
        params: {
            requiredDictionaries: ['SiteAll'],
        },
    });
};

export const monitoringServerTime = (): Promise<AxiosResponse<IMonitoringServerTime>> => {
    return axios.get('/api/monitoring/serverTime');
};
